export default "__VITE_ASSET__CbZi2ivB__"